import React from 'react';

const MobileMenu = () => {
    return (
        <div className="mobile-menu">
            <span>mobile menu</span>
        </div>
    )
};

export default MobileMenu;


// WEBPACK FOOTER //
// ./src/components/shared/MobileMenu.js